
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy",
      function () {
        return require("private-next-pages/policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy"])
      });
    }
  